export const CHAT_HEADER_END = 'END_CHAT';
export const CHAT_HEADER_ACCEPT_DECLINE = 'ACCEPT_DECLINE_CHAT';
export const RCS_TYPING_INDICATOR_WINDOW = 3000; // 3 seconds
